export const FilterThresholds = {
  good: { low: 61, high: 100 },
  warning: { low: 41, high: 60 },
  alert: { low: 0, high: 40 },
};

export const filterThresholdForValue = (value: number) => {
  for (const [key, threshold] of Object.entries(FilterThresholds)) {
    if (value >= threshold.low && value <= threshold.high) {
      return key;
    }
  }
  return undefined;
};

export enum FilterStatus {
  FilterGood = 'filterGood',
  ReplaceFilter = 'replaceFilter',
  ReplaceFilterUrgent = 'replaceFilterUrgent',
  NoData = 'noData',
  NoSensor = 'noSensor',
}

export enum FilterReplacementStatus {
  FilterChangeUpcoming = 'FilterChangeUpcoming',
  FilterChangeOverdue = 'FilterChangeOverdue',
  HVACFilterAlert = 'HVACFilterAlert', // New: For actual HVAC_FILTER alerts from backend
  HVACFilterAlertModerate = 'HVACFilterAlertModerate', // Moderate priority (< 60%)
  HVACFilterAlertCritical = 'HVACFilterAlertCritical', // Critical priority (≤ 40%)
  ServiceRequested = 'ServiceRequested',
  FilterOrdered = 'FilterOrdered',
  NoFilterChangeNeeded = 'NoFilterChangeNeeded',
}

export interface HVACFilterReading {
  label: string;
  value: number;
  timestamp: string;
  rawValue: number;
}

export interface HVACStatusResult {
  filterStatus: string;
  replacementTime: string;
  hvac: string;
  filterReplacementStatus: FilterReplacementStatus | null;
  thresholdCategory: string;
}

export const calculateHVACStatus = (percentPressure: number): HVACStatusResult => {
  const thresholdCategory = filterThresholdForValue(percentPressure) || 'good';
  let filterReplacementStatus: FilterReplacementStatus | null = null;
  let filterStatus: string;
  let replacementTime: string;

  switch (thresholdCategory) {
    case 'good':
      filterStatus = FilterStatus.FilterGood;
      replacementTime = 'inThreeMonths';
      break;
    case 'warning':
      filterStatus = FilterStatus.ReplaceFilter;
      replacementTime = 'inTwoWeeks';
      filterReplacementStatus = FilterReplacementStatus.FilterChangeUpcoming;
      break;
    case 'alert':
      filterStatus = FilterStatus.ReplaceFilterUrgent;
      replacementTime = 'now';
      filterReplacementStatus = FilterReplacementStatus.FilterChangeOverdue;
      break;
    default:
      filterStatus = FilterStatus.FilterGood;
      replacementTime = 'inThreeMonths';
  }

  return {
    filterStatus,
    replacementTime,
    hvac: 'hvac',
    filterReplacementStatus,
    thresholdCategory,
  };
};

export const getHVACStatusForNoData = (): HVACStatusResult => ({
  filterStatus: FilterStatus.NoData,
  replacementTime: 'unknown',
  hvac: 'hvac',
  filterReplacementStatus: null,
  thresholdCategory: 'good',
});

export const getHVACStatusForNoSensor = (): HVACStatusResult => ({
  filterStatus: FilterStatus.NoSensor,
  replacementTime: 'unknown',
  hvac: 'hvac',
  filterReplacementStatus: null,
  thresholdCategory: 'good',
});
